import { COVERAGE_STATUS_LABEL } from '@/modules/projects/components/StatementCoverage/constants'
import {
  accountStatusInSegment,
  paintedAccountLast4s,
} from '@/modules/projects/components/StatementCoverage/deriveCoverage'
import type { StatementSegment } from '@/modules/projects/stores/types'
import { cn } from '@/utils'
import { AccountNumber } from './AccountNumber'
import { COVERAGE_SWATCH_CLASS } from './coverage'

// A statement mailed for several accounts is checked account by account, and one can reconcile
// while another does not. Each gets its own line, in the colour its bar has on the map.
export const AccountVerdicts = ({ segment }: { segment: StatementSegment }) => {
  const numbers = paintedAccountLast4s(segment)
  if (numbers.length < 2) return null

  return (
    <ul className="mt-2 space-y-1 text-xs">
      {numbers.map((number) => {
        const status = accountStatusInSegment(segment, number)
        return (
          <li key={number} className="flex items-center gap-2">
            <span
              className={cn(
                'size-2 shrink-0 rounded-full',
                COVERAGE_SWATCH_CLASS[status],
              )}
            />
            <AccountNumber numbers={[number]} />
            <span className="text-ink-subtle">
              {COVERAGE_STATUS_LABEL[status]}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
